module.exports = __webpack_public_path__ + "static/media/04. Grafie.4e6ba7c0.png";